import { EventEmitter } from 'events';

/* 
* The GlobalEventDistributor is an event driven utility with the sole
* purpose of extending functionality without coupling it to any one component.
*/

let GlobalEventEmitter;

export function getGlobalEventEmitter() {
    GlobalEventEmitter = GlobalEventEmitter || new EventEmitter();
    return GlobalEventEmitter;
}